module.exports = __webpack_public_path__ + "components/forecast-table/static/icon-chevron-left-c0877d6f7f20e4fbe6df53b3a56f7308.svg";